import React from "react";
import { ItemList } from "@/components/dragndrop/dndItemList";
import styles from "@/components/dragndrop/dndColumn.module.css";

interface Props {
  column?: any;
  index?: any;
  preExistingFormElements?: any;
  onHandleCheckboxChange?: (id: string) => void;
  onHandleRulesetChange?: (event: any, id: any) => void;
  leftColumnPlaceholderText?: string;
  handleDeleteItem?: (id: string | undefined) => void;
  onMoveItem?: (index: number, direction: 1 | -1) => void;
  showFieldPreview?: boolean;
  keySuggestions?: { value: string; label?: string }[];
  invalidRulesetItemId?: string | null;
  registerRulesetValidationTarget?: (
    itemId: string,
  ) => React.RefCallback<HTMLElement>;
}

export const Column = React.memo(function Column({
  column,
  index,
  preExistingFormElements,
  onHandleCheckboxChange,
  onHandleRulesetChange,
  leftColumnPlaceholderText,
  handleDeleteItem,
  onMoveItem,
  showFieldPreview,
  keySuggestions,
  invalidRulesetItemId,
  registerRulesetValidationTarget,
}: Props) {
  return (
    <div className={styles.columnRoot}>
      {column.title && (
        <div className={styles.columnHeader}>
          <h5 className={styles.columnTitle}>{column.title}</h5>
        </div>
      )}
      <div className={styles.listArea}>
        <ItemList
          column={column}
          index={index}
          handleDeleteItem={handleDeleteItem}
          preExistingFormElements={preExistingFormElements}
          onHandleCheckboxChange={onHandleCheckboxChange}
          onHandleRulesetChange={onHandleRulesetChange}
          leftColumnPlaceholderText={leftColumnPlaceholderText}
          onMoveItem={onMoveItem}
          showFieldPreview={showFieldPreview}
          keySuggestions={keySuggestions}
          invalidRulesetItemId={invalidRulesetItemId}
          registerRulesetValidationTarget={registerRulesetValidationTarget}
        />
      </div>
    </div>
  );
});
